<template>
  <div
    class="flex items-center bg-[#F7F7FA] px-2.5 text-sm text-gray-700 rounded-b-md mt-3 -mb-3 -mx-3"
    style="min-width: 1px;"
  >
    <slot />
  </div>
</template>
